import ApiService from '@/core/services/api.service';

const resource = '/v1/product-revenue-report';

export default {
  /**
   * Get revenue overview KPI data
   * @param {Object} params - { startDate, endDate, storeId, compareWithPreviousPeriod }
   * @returns {Promise}
   */
  getOverview(params) {
    return ApiService.get(`${resource}/overview`, { params });
  },

  /**
   * Get product performance data with pagination
   * @param {Object} params - { startDate, endDate, storeId, categoryId, brandId, search, sortBy, sortOrder, limit, offset }
   * @returns {Promise}
   */
  getProducts(params) {
    return ApiService.get(`${resource}/products`, { params });
  },

  /**
   * Get revenue trend time series data
   * @param {Object} params - { startDate, endDate, storeId, granularity, metric, compareWithPreviousPeriod }
   * @returns {Promise}
   */
  getTrend(params) {
    return ApiService.get(`${resource}/trend`, { params });
  },

  /**
   * Get store comparison data
   * @param {Object} params - { startDate, endDate, storeIds, sortBy, sortOrder, compareWithPreviousPeriod }
   * @returns {Promise}
   */
  getStores(params) {
    return ApiService.get(`${resource}/stores`, { params });
  },

  /**
   * Get category revenue aggregated data
   * @param {Object} params - { startDate, endDate, storeId, sortBy, sortOrder, compareWithPreviousPeriod }
   * @returns {Promise}
   */
  getCategories(params) {
    return ApiService.get(`${resource}/categories`, { params });
  },

  /**
   * Queue export job
   * @param {Object} data - { format, reportType, filters }
   * @returns {Promise}
   */
  exportReport(data) {
    return ApiService.post(`${resource}/export`, data);
  },

  /**
   * Get export job status
   * @param {string} jobId - Export job ID
   * @returns {Promise}
   */
  getExportStatus(jobId) {
    return ApiService.get(`${resource}/export/${jobId}`);
  },

  /**
   * Get download URL for completed export
   * @param {string} jobId - Export job ID
   * @returns {string} Download URL
   */
  getExportDownloadUrl(jobId) {
    return `${ApiService.defaults.baseURL}${resource}/export/${jobId}/download`;
  },
};
